import { NgModule } from '@angular/core';
import { FooterPageComponent } from './footer-page.component';
import { FooterPageRoutingModule } from './footer-page-routing.module';
import { SharedModule } from '../@shared/shared.module';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';

@NgModule({
    declarations: [FooterPageComponent],
    imports: [
        CommonModule,
        SharedModule,
        FooterPageRoutingModule,
        MatExpansionModule,
        // UtilitiesModule,
    ],
    exports: [FooterPageComponent],
})
export class FooterPageModule {
    constructor() {}
}
